import type { Experience } from '@experience/exp-card/dist/types/experience';
import { mapExperienceDataToSogu } from '@/entities/experience/sogu';
import { trackEvent } from '@/entities/sogu';
import { useExperienceFavorites } from '@/entities/experience/favorite';
import type { action } from '@/shared/api/sogu';
import type { ContextGeoSubject } from '@/shared/types/geography.ts';
import type { IExpSelection } from '@/entities/expSelection/model/expSelection.ts';
import { useExcursionSoguStore } from '@/features/sogu/excursion';

export const useExcursionExperienceFavoriteSogu = () => {
  const { isFavorite } = useExperienceFavorites();
  const soguStore = useExcursionSoguStore();

  const trackSectionFavoriteClick = (
    exp: Experience,
    contextGeoSubject: ContextGeoSubject,
    selection: IExpSelection,
  ) => {
    return trackEvent(`listing:section:experience:add-to-favorite.click`, {
      ...getEventParams(exp, contextGeoSubject),
      ...selection.extendedSoguParams,
    });
  };

  const trackExperiencesFavoriteClick = (exp: Experience, contextGeoSubject: ContextGeoSubject) => {
    return trackEvent(`listing:experiences:experience:add-to-favorite.click`, getEventParams(exp, contextGeoSubject));
  };

  const getEventParams = (exp: Experience, contextGeoSubject: ContextGeoSubject) => {
    const action: action = isFavorite(exp.id) ? 'remove' : 'add';

    return {
      action,
      citytag: soguStore.rubricId,
      ...mapExperienceDataToSogu(exp),
      ...contextGeoSubject.soguStamp,
    };
  };

  return {
    trackSectionFavoriteClick,
    trackExperiencesFavoriteClick,
  };
};
